import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#F23030" rx={4} />
    <path
      fill="#fff"
      d="M5.996 15V9.784h1.792q.433 0 .808.088.377.08.656.28.28.192.44.52.168.32.168.792 0 .456-.168.792a1.5 1.5 0 0 1-.44.552 1.9 1.9 0 0 1-.648.32 2.8 2.8 0 0 1-.784.104h-.648V15zm1.176-2.704h.576q.96 0 .96-.832 0-.408-.256-.576t-.736-.168h-.544zM10.362 15V9.784h1.472q.6 0 1.08.152t.824.472q.344.312.528.8t.184 1.16-.184 1.168q-.184.495-.52.824a2.2 2.2 0 0 1-.808.48q-.464.16-1.04.16zm1.176-.952h.224q.336 0 .608-.088t.464-.28q.192-.2.296-.52.112-.32.112-.792 0-.465-.112-.776a1.2 1.2 0 0 0-.296-.504 1.1 1.1 0 0 0-.464-.272 2.2 2.2 0 0 0-.608-.08h-.224zM15.04 15V9.784h3.288v.992h-2.112v1.208h1.808v.992h-1.808V15z"
    />
  </svg>
);
export default SvgPdf;
